// FT-216 REQ-04, OQ-04: процент поправки на даты в таблицах сезонов форм бронирования
// («24.10–25.10: +10 %»). Строка rental_unit котировки несёт adjustment_percent
// (nullable, CTR-05); суффикс стоит в ячейке цены строки, новой колонки нет.
// Пусто — поправки у строки нет (поле null/отсутствует у старого api). Поправка 0 % — «0 %»: она есть.
export function formatAdjustmentPercent(percent) {
  if (percent == null || percent === "") return "";
  const n = Number(percent);
  if (!Number.isFinite(n)) return "";
  const rounded = Math.round(n * 100) / 100;
  if (rounded === 0) return "0 %";
  return `${rounded > 0 ? "+" : "-"}${Math.abs(rounded)} %`;
}
